<template>
  <div class="w1200 newsBox1">
    <div style="overflow: hidden;background-color: #fff;">
      <div class="leftBox">
        <div v-if="bookData.length>0" class="showlist">
          <a v-for="(item,index) in bookData" :key="index" :href="'/sourceView?sourceId='+item.BOOK_ID+'&type=1'" target="_blank" class="lilist">
            <div class="imgBox">
              <img :src="item.SHOW_THUMB_URL" alt="">
            </div>
            <div class="tipBox">
              <img :src="topmsgPng" alt="">
              <span>{{ item.PRIVACY_RULE|changeType }}</span>
            </div>
            <div class="hovermsg">
              <p>{{ item.SHOW_TITLE }}</p>
              <span class="Btype">{{ item.BOOK_TYPE|changeBookType }}</span>
              <div class="hovermsg_div">
                <img :src="item.HEADIMGURL" alt="">
                <span>{{ item.USER_NAME }}</span>
              </div>
              <div class="showTime">
                {{ item.UPDATE_DATE }}
              </div>
              <div class="hovermsg_btn">
                <span><svg-icon icon-class="chakan" /></span>
                <a :href="'/sourceView?sourceId='+item.BOOK_ID+'&type=1'" target="_blank">查看详情</a>
              </div>
            </div>
          </a>
        </div>
        <div v-else style="text-align: center;font-size: 20px;color: #a19d9e;font-weight: 600;background-color: #ffffff;height: 150px;line-height: 150px;">
          暂无数据
        </div>
      </div>
    </div>
    <!--<div>2</div>-->
  </div>
</template>
<script>
import { getShowBookRecommend } from '@/api/api.js'
export default {
  filters: {
    changeType: val => {
      if (val == 1) {
        return '完全公开'
      }
      if (val == 2) {
        return '完全保密'
      }
      if (val == 3) {
        return '付费查阅'
      }
      if (val == 4) {
        return '密码查阅'
      }
    },
    changeBookType: val => {
      if (val == 1) {
        return '智能家谱'
      }
      if (val == 2) {
        return '电子家谱'
      }
    }
  },
  data() {
    return {
      bookData: [],
      topmsgPng: require('@/static/tipmsg.png')
    }
  },
  mounted() {
    this.fn()
    this.initData()
  },
  methods: {
    fn: function() {
      window.scrollTo(0, 0)
    },
    initData() {
      var obj = {
        index: 1,
        size: 8,
        showType: 1
      }
      // if (this.$route.query.classz) {
      //   obj.type = this.$route.query.type
      // }
      getShowBookRecommend(obj).then(res => {
        // console.log(res.data)
        this.bookData = res.data.listMapData
      })
    },
    goDetail(sourceId, type) {
      const { href } = this.$router.resolve({
        url: '/sourceView',
        name: 'sourceView',
        query: {
          sourceId,
          type
        }
      })
      window.open(href, '_blank')
    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    ///列表样式
    .pushu_nav{
        overflow: hidden;
        text-align: center;
        background-color: #fff;
        height: 60px;
        line-height: 60px;
        margin-top: 20px;
        margin-bottom: 20px;
        span{
            font-size: 15px;
            color: #333333;
        }
        .names{
            .span_name{
                cursor: pointer;
                color: #333333;
                font-weight: 600;
                font-size: 16px;
            }
        }
        .activenames{
            .span_name{
                cursor: pointer;
                color: #E3003A;
                font-weight: 600;
                font-size: 16px;
            }
        }
    }
    .showlist{
        width: 100%;
        /*overflow: hidden;*/
        font-size: 0;
        .lilist{
            margin-bottom: 20px;
            background-color: #fff;
            position: relative;
            /*margin-top: 43px;*/
            display: inline-block;
            width: 179px;
            overflow: hidden;
            margin-right: 40px;
            box-shadow: 2px 2px 2px 2px hsla(0,0%,72%,.5);
            .imgBox{
                display: inline-block;
                width: 179px;
                height: 225px;
                text-align: center;
                background-color: #fff;
                padding: 10px 0;
                img{
                    width: 159px;
                    height: 225px;
                    cursor: pointer;
                }
            }

            p{
                color: #333333;
                margin-top: 5px;
                font-size: 15px;
                height: 40px;
                overflow: hidden;
            }
            .tip{
                position: absolute;
                top: 7px;
                left: 9px;
                display: inline-block;
                width: 60px;
                background-color:rgba(0,0,0,.3);
                color: #ffffff;
                height: 20px;
                line-height: 20px;
                font-size: 12px;
                text-align: center;
                border-radius: 2px;
                cursor: pointer;
                &:hover{
                    color: #ed4040;
                }
            }
        }
        .lilist:nth-child(4n){
            margin-right: 0;
        }
    }
    .addMore{
        height: 45px;
        line-height: 45px;
        font-size: 14px;
        color: #999999;
        background-color: #fff;
        border: 1px solid #e5e5e5;
        border-radius: 3px;
        cursor: pointer;
        display: inline-block;
        width: 100%;
        margin-top: 20px;
        transition: 0.5s;
        text-align: center;
        margin-bottom: 60px;
        .addMore_span{
            cursor: pointer;
        }
        &:hover{
            border: 1px solid #E3003A;
            color: #E3003A;
        }
    }
    .tipBox{
        position: absolute;
        width: 27px;
        height: 70px;
        display: inline-block;
        top: 10px;
        left: 20px;
    }
    .tipBox img{
        width: 27px;
        height: 70px;
    }
    .tipBox span{
        position: absolute;
        width: 70px;
        height: 20px;
        top: 31px;
        left: -22px;
        font-size: 12px;
        color: #ffffff;
        transform: rotate(90deg);
    }
    .hovermsg{
        position: absolute;
        z-index: 3;
        width: 159px;
        height: 225px;
        border: 1px solid #ECECEC;
        top: 310px;
        left: 10px;
        background-color: #fff;
        text-align: center;
        transition: 1s;
    }
    .hovermsg .Btype{
        display: inline-block;
        width: 80px;
        text-align: center;
        border: 1px solid #ed4040;
        height: 18px;
        line-height: 18px;
        font-size: 14px;
        border-radius: 3px;
        color: #666;
        margin-top: 10px;
    }
    .hovermsg .hovermsg_div{
        padding-top: 10px;
        height: 36px;
        line-height: 36px;
        text-align: center;
        img{
            width: 36px;
            height: 36px;
            border-radius: 50%;
            vertical-align: top;
        }
        span{
            font-size: 15px;
            color: #333;
            display: inline-block;
            height: 36px;
            line-height: 36px;
            vertical-align: top;
            margin-left: 10px;
            max-width: 110px;
           overflow: hidden;
        }
    }
    .hovermsg .showTime{
        margin-top: 10px;
        font-size: 13px;
        color: #333333;
    }
    .hovermsg  .hovermsg_btn{
        height: 40px;
        line-height: 40px;
        background-color: #E3013A;
        width: 120px;
        display: inline-block;
        margin-top: 10px;
        cursor: pointer;
        span{
            color: #ffffff;
            font-size: 16px;
            svg{
                font-size: 18px;
                margin-right: 5px;
            }
        }
        a{
            color: #ffffff;
            font-size: 16px;
        }
    }
    .showlist .lilist .hovermsg p{
        font-size: 16px;
        font-weight: 600;
        padding: 0 10px;
        padding-top: 10px;
        text-align: center;
        height: 40px;
        line-height: 20px;
        overflow: hidden;
        color: #333;
    }
    .lilist:hover >.hovermsg{
        top: 10px;
    }

    .firstcolumn_tip{
        margin-top: 20px;
        height: 68px;
        /*border: 1px solid #f0f0f0;*/
        text-align: center;
        line-height: 68px;
        background-color: #fff;
        font-size: 24px;
        color: #353535;
        font-weight: 600;
        img{
            width:auto;
            height: 29px;
            margin-top: 20px;
        }
    }
    .leftBox{
        float: left;
        overflow: hidden;
        .bannerBox{
            width: 880px;
            height: 340px;
            font-size: 0;
            img{
                width:100%;
                height: 340px;
            }
        }
    }
    .rightBox{
        width: 300px;
        margin-top: 20px;
        float: right;
        overflow: hidden;
    }
    .newsBox1 {
        position: relative;
        width: 100%;
        background-color: #F9F9F9;
        .top {
            position: absolute;
            top: 0;
            width: 100%;
            height: 140px;
            top: -180px;
            z-index: 9;
            background-color: #fff;
            .navs {
                height: 40px;
                background-color: #7e6b5a;
                width: 100%;
                .w1200s {
                    width: 1200px;
                    height: 40px;
                    background-color: #7e6b5a;
                    margin: 0 auto;
                    position: relative;
                    .head-ul {
                        display: inline-block;
                        overflow: hidden;
                        height: 40px;
                        background-color: #7e6b5a;
                        li {
                            display: inline-block;
                            margin-top: 10px;
                            a {
                                padding: 5px 14px;
                                margin: 0 5px;
                                cursor: pointer;
                                color: #ffffff;
                            }
                        }
                    }
                    .right_box {
                        display: inline-block;
                        float: right;
                        .login_register {
                            border-radius: 5px;
                            float: right;
                            width: 88px;
                            height: 28px;
                            margin: 5px 20px;
                            line-height: 28px;
                            /*border: 1px solid #ed4040;*/
                            a {
                                display: inline-block;
                                width: 42px;
                                text-align: center;
                                height: 16px;
                                margin-top: 6px;
                                font-size: 12px;
                                line-height: 16px;
                                color: #ffffff;
                            }
                        }
                        .login_register a:nth-of-type(1) {
                            border-right: 1px solid #fff;
                        }
                        .userBox {
                            border-radius: 5px;
                            width: 90px;
                            height: 30px;
                            margin: 5px 20px;
                            line-height: 30px;
                            transition: 0.5s;
                            position: absolute;
                            z-index: 5;
                            right: 0;
                            top: 0;
                            overflow: hidden;
                            &:hover {
                                height: 240px;
                            }
                            .imgBox {
                                width: 30px;
                                height: 30px;
                                border-radius: 50%;
                                display: inline-block;
                                background-color: #e6e6e6;
                                vertical-align: top;
                                cursor: pointer;
                                font-size: 0;
                                img {
                                    width: 30px;
                                    height: 30px;
                                    border-radius: 50%;
                                }
                            }
                            .usercontent {
                                width: 150px;
                                display: inline-block;
                                height: 30px;
                                font-size: 12px;
                                color: #ffffff;
                                /*overflow: hidden;*/
                                margin-left: 5px;
                                cursor: pointer;
                                position: absolute;
                                z-index: 6;
                            }
                            .list {
                                margin-top: 10px;
                                background-color: #fff;
                                li {
                                    text-align: center;
                                    height: 36px;
                                    line-height: 36px;
                                    font-size: 12px;
                                    cursor: pointer;
                                    &:hover {
                                        background-color: #ed4040;
                                    }
                                }
                            }
                        }
                    }
                }
            }
            .logoBox {
                width: 444px;
                height: 60px;
                font-size: 0;
                display: inline-block;
                cursor: pointer;
                margin-top: 40px;
                vertical-align: top;
                img {
                    width: 444px;
                    height: 60px;
                }
            }
            .searchbox {
                display: inline-block;
                overflow: hidden;
                float: right;
                margin-top: 45px;
                span {
                    display: inline-block;
                    height: 38px;
                    width: 98px;
                    border: 1px solid #7e6b5a;
                    vertical-align: top;
                    text-align: center;
                    line-height: 40px;
                }
                .keys_input {
                    height: 38px;
                    width: 313px;
                    border-top: 1px solid #7e6b5a;
                    border-bottom: 1px solid #7e6b5a;
                    border-left: 1px solid #7e6b5a;
                    padding-left: 5px;
                    vertical-align: top;
                }
                .btn {
                    display: inline-block;
                    background-color: #7e6b5a;
                    color: #ffffff;
                    line-height: 40px;
                    height: 40px;
                    text-align: center;
                    width: 101px;
                    cursor: pointer;
                }
            }
            .bannerbox {
                width: 100%;
                height: 500px;
                font-size: 0;
                margin-top: 40px;
                position: relative;
                background-position: center center;
                background-size: auto 100%;
                img {
                    width: 100%;
                    height: 500px;
                }
                .numberCount {
                    position: absolute;
                    top: 332px;
                    width: 100%;
                    text-align: center;
                    color: #bb955b;
                    font-family: '微软宋体';
                }
            }
        }
    }
</style>
<!--手机端样式-->
<style rel="stylesheet/scss" lang="scss" scoped>
    @media screen and (max-width: 750px) {
        .showlist .lilist .hovermsg p{
            padding-top: 0;
            margin-top: 0;
        }
        .top{
            display: none;
        }
        .leftBox{
            width: 100%;
            margin-top: 0;
            .bannerBox{
                width: 100%;
                height: auto;
                img{
                    width: 100%;
                    height: auto;
                }
            }
            .firstcolumn_tip{
                width: 100%;
                height: auto;
                background-color: #fff;
                text-align: center;
                img{
                    width: 90%;
                    height: auto;
                }
            }
            .columnBoxInnnerList{
                white-space: nowrap;
                padding: 0 20px;
            }
            .pushu_nav{
                width: 100%;
                overflow: hidden;
                padding-bottom: 20px;
                overflow-x: auto;
                span{
                    float: none;
                    margin: 0 auto 20px;
                }
            }
        }
        .showlist{
            text-align: center;
            padding: 0 0;
            width: auto;
            background-color: #fff;
            .lilist{
                width: 100%;
                box-shadow:none;
                border-bottom: 1px solid #eee;
                padding-bottom: 0px;
                .hovermsg{
                    width: 70%;
                    float: left;
                    top: 0;
                    height: 100px;
                    border: none;
                    .hovermsg_btn{
                        display: none;
                    }
                    .Btype{
                        display: none;
                    }
                    p{
                        font-size: 14px;
                        text-align: left;
                        padding-top: 10px;
                        padding-left: 0;
                    }
                    .hovermsg_div{
                        text-align: left;
                        margin-top: 0;
                        padding-top: 0;
                        img{
                            width: 30px;
                            height: 30px;
                            margin-top: 3px;
                        }
                    }
                    .showTime{
                        text-align: left;
                    }
                }
                .imgBox{
                    width: 30%;
                    height: 100px;
                    overflow: hidden;
                    float: right;
                    padding: 10px 0px;
                    img{
                        height: 90px;
                        width: auto;
                    }
                }
            }
        }
        .rightBox{
            display: none;
        }
      .newsBox1{
        padding: 0;
      }
    }
</style>
